import { render, staticRenderFns } from "./ProductSkeleton.vue?vue&type=template&id=382604f9&scoped=true&"
import script from "./ProductSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ProductSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSkeleton.vue?vue&type=style&index=0&id=382604f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382604f9",
  null
  
)

export default component.exports